//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
export default {
  props: ['resources', 'loadstate', 'resource_type'],
  components: {
    videoItem: () => import('~/components/content/video/video.vue'),
    dummyCollection: () => import('~/components/content/dummy/collection.vue')
  }
}
